import styled from 'styled-components';
import LeftArrowIconHome from '../assets/hotels/home/arrow-left.svg';

const LeftArrowIcon = styled(LeftArrowIconHome as React.SFC<React.SVGProps<SVGSVGElement>>)`
  fill: ${props =>
    props.isactive === 'true'
      ? props.theme.colors.goBrandBlue.base
      : props.theme.colors.goBrandBlue.medium};
  width: ${props => props.theme.font.custom(16)};
  height: ${props => props.theme.font.custom(16)};
`;

export default LeftArrowIcon;
